import { ALPHA_EQUAL_A_ZERO } from "../../constants";
import { berechneKnicken } from "../knickenBerechnungen.service";

export const berechneAci = (verpresskoerperdurchmesser, aussendurchmesser) => {
  return (
    (Math.PI / 4) *
    (Math.pow(Number(verpresskoerperdurchmesser), 2) - Math.pow(aussendurchmesser, 2))
  );
};

export const brechneNormalkrafttragfaehigkeit = (
  querschnitt,
  charakteristischeFestigkeit,
  Aci,
  teilsicherheitsbeiwertStahltragglied,
  teilsicherheitsbeiwertZement
) => {
  let result =
    Number(querschnitt) * (charakteristischeFestigkeit / teilsicherheitsbeiwertStahltragglied) +
    0.85 * Aci * 0.85 * (0.035 / teilsicherheitsbeiwertZement);

  return result;
  // Number(querschnitt) *
  //   (charakteristischeFestigkeit / teilsicherheitsbeiwertStahltragglied) +
  // 0.85 * Aci * 0.85 * (0.035 / teilsicherheitsbeiwertZement)
  //  );
};

export const berechneQq = (
  kc,
  verpresskoerperdurchmesser,
  undraenierteScherfestigkeit,
  teilsicherheitsbeiwert
) => {
  return (
    (Number(kc) * Number(verpresskoerperdurchmesser) * Number(undraenierteScherfestigkeit)) /
    1_000_000 /
    teilsicherheitsbeiwert
  );
};

export const berechneElastischerBereichDerSeitlichenBettung = (ky, verpresskoerperdurchmesser) => {
  return Number(ky) * Number(verpresskoerperdurchmesser);
};

export const berechneC = (elastischerBereichDerSeitlichenBettung, qy_calc) => {
  if (Number(elastischerBereichDerSeitlichenBettung) == 0) return 0.0;

  return Number(qy_calc) / Number(elastischerBereichDerSeitlichenBettung);
};

export const berechneM = (biegesteifigkeit, dickeWeicheBodenschicht, c) => {
  let power4 = Math.pow(c / Number(biegesteifigkeit), 1 / 4) * 1000;

  let m = (Number(dickeWeicheBodenschicht) / Math.PI) * power4;
  if (m < 1) return 1;

  return m;
};

export const berechneLhw = (dickeWeicheBodenschicht, m) => {
  return (Number(dickeWeicheBodenschicht) * 1_000) / m;
};

export const berechneNki = (biegesteifigkeit, lhw) => {
  return (Math.pow(Math.PI, 2) * biegesteifigkeit) / Math.pow(lhw, 2);
};

export const berechneKnicklastDesGebettetenPfahls = (nki, c, lhw) => {
  return nki + (c * Math.pow(lhw, 2)) / Math.pow(Math.PI, 2);
};

export const berechneLambda = (querschnitt, charakteristischeFestigkeit, nki) => {
  return Math.sqrt((querschnitt * charakteristischeFestigkeit) / nki);
};

export const berechneErsatzimperfektionsamplitude = (lamba1, widerstandsmoment, querschnitt) => {
  return Number(ALPHA_EQUAL_A_ZERO) * (lamba1 - 0.2) * (widerstandsmoment / querschnitt);
};

export const berechneBiegemomentdesPfahls = (
  bemessungslast,
  ersatzimperfektionsamplitude,
  nki,
  knicklastDesGebettetenPfahls
) => {
  return (
    Number(bemessungslast) *
    ersatzimperfektionsamplitude *
    (nki / (knicklastDesGebettetenPfahls - Number(bemessungslast)))
  );
};

export const berechneVerformungsamplitude = (
  ersatzimperfektionsamplitude,
  bemessungslast,
  knicklastDesGebettetenPfahls
) => {
  return (
    ersatzimperfektionsamplitude *
    (Number(bemessungslast) / (knicklastDesGebettetenPfahls - Number(bemessungslast)))
  );
};

export const berechneKnickenOfner = (
  biegesteifigkeit,
  knickkoeffizient,
  traggliedDaten,
  verpresskoerperdurchmesser,
  teilsicherheitsbeiwertTragglied,
  koeffizientNachWenz,
  undraenierteScherfestigkeit,
  koeffizientNachGudehus,
  dickeWeicheBodenschicht,
  bemessungslast,
  teilsicherheitsbeiwertFuerGeotechnischenKenngroessen,
  teilsicherheitsbeiwertZement
) => {
  let berechneteKnickenWerte = berechneKnicken({
    biegesteifigkeit,
    knickkoeffizient,
    traggliedDaten,
  });

  let Aci = berechneAci(verpresskoerperdurchmesser, berechneteKnickenWerte?.aussendurchmesser);

  let normalkrafttragfaehigkeit = brechneNormalkrafttragfaehigkeit(
    traggliedDaten?.querschnitt,
    berechneteKnickenWerte?.charakteristischeFestigkeit,
    Aci,
    teilsicherheitsbeiwertTragglied,
    teilsicherheitsbeiwertZement
  );

  let elastischeMomententragfaehigkeit =
    (berechneteKnickenWerte.widerstandsmoment *
      berechneteKnickenWerte.charakteristischeFestigkeit) /
    teilsicherheitsbeiwertTragglied;

  let qy_calc = berechneQq(
    koeffizientNachWenz,
    verpresskoerperdurchmesser,
    undraenierteScherfestigkeit,
    teilsicherheitsbeiwertFuerGeotechnischenKenngroessen
  );

  let elastischerBereichDerSeitlichenBettung = berechneElastischerBereichDerSeitlichenBettung(
    koeffizientNachGudehus,
    verpresskoerperdurchmesser
  );

  let c_calc = berechneC(elastischerBereichDerSeitlichenBettung, qy_calc);

  let m_calc = berechneM(traggliedDaten?.knicken.biegesteifigkeit, dickeWeicheBodenschicht, c_calc);

  let lhw_calc = berechneLhw(dickeWeicheBodenschicht, m_calc);

  let nki_calc = berechneNki(traggliedDaten?.knicken.biegesteifigkeit, lhw_calc);

  let knicklastDesGebettetenPfahls = berechneKnicklastDesGebettetenPfahls(
    nki_calc,
    c_calc,
    lhw_calc
  );

  let lamba1_calc = berechneLambda(
    traggliedDaten?.querschnitt,
    berechneteKnickenWerte.charakteristischeFestigkeit,
    nki_calc
  );

  let ersatzimperfektionsamplitude = berechneErsatzimperfektionsamplitude(
    lamba1_calc,
    berechneteKnickenWerte.widerstandsmoment,
    traggliedDaten?.querschnitt
  );

  let biegemomentdesPfahls = berechneBiegemomentdesPfahls(
    bemessungslast,
    ersatzimperfektionsamplitude,
    nki_calc,
    knicklastDesGebettetenPfahls
  );

  let verformungsamplitude = berechneVerformungsamplitude(
    ersatzimperfektionsamplitude,
    bemessungslast,
    knicklastDesGebettetenPfahls
  );

  return {
    berechneteKnickenWerte,
    Aci,
    normalkrafttragfaehigkeit,
    elastischeMomententragfaehigkeit,
    qy_calc,
    elastischerBereichDerSeitlichenBettung,
    c_calc,
    m_calc,
    lhw_calc,
    nki_calc,
    knicklastDesGebettetenPfahls,
    lamba1_calc,
    ersatzimperfektionsamplitude,
    biegemomentdesPfahls,
    verformungsamplitude,
  };
};
